module.exports = __webpack_public_path__ + "img/green_121.4f148ab9.png";